import { useCallback, useEffect, useRef } from "react";
import { DEFAULT_DEBOUNCE_INTERVAL } from "../appContants";

/**
 * Returns a function that resets a trailing-edge timer on each call.
 * The callback runs once `debounceInterval` ms after the last call.
 */
const useDebounce = (cb, debounceInterval = DEFAULT_DEBOUNCE_INTERVAL) => {
    const timeoutRef = useRef(null);
    const cbRef = useRef(cb);
    cbRef.current = cb;

    const clear = useCallback(() => {
        if (timeoutRef.current !== null) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, []);

    useEffect(() => () => clear(), [clear]);

    const pauseAndRestart = useCallback(() => {
        clear();
        timeoutRef.current = setTimeout(() => {
            timeoutRef.current = null;
            cbRef.current();
        }, debounceInterval);
    }, [clear, debounceInterval]);

    return pauseAndRestart;
};

export default useDebounce;
